import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { UpsertExternalIntegrationDto } from "./useRegisterExternalIntegration";

const updateSpec = (businessId: string, clientId: string): UserRequestSpec => ({
  path: `/api/businesses/${businessId}/externalIntegrations/${clientId}`,
  method: HttpMethod.PUT,
});

const useUpdateExternalIntegration = (clientId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<UpsertExternalIntegrationDto>(updateSpec(business.id, clientId), options);
}

export default useUpdateExternalIntegration;
